// Function that returns the url for a single country request
const createSingleCountryRequest = (dataset, entity, selectedCountry) => {
  const baseURL = "https://ember-data-api-scg3n.ondigitalocean.app/ember";
  const format = ".json";
  const sort = "?_sort=rowid";
  const entityPromptExact = "&country__exact=";
  const countryPromptExact = "&state__exact=";
  const returnShape = "&_shape=array";
  const month_low_limit =
    dataset.apiDatasetTitle === "generation_monthly"
      ? "&date__gte=2015-01-01"
      : "";

  const url =
    baseURL +
    "/" +
    dataset.apiDatasetTitle +
    format +
    sort +
    entityPromptExact +
    entity.replace(/\s/g, "+") +
    countryPromptExact +
    selectedCountry.replace(/\s/g, "+") +
    month_low_limit +
    returnShape;

  return url;
};

// Function that returns the url for a multi country request
const createMultiCountryRequest = (
  dataset,
  entity,
  selectedCountries,
  fuel
) => {
  const baseURL = "https://ember-data-api-scg3n.ondigitalocean.app/ember";
  const format = ".json";
  const sort = "?_sort=rowid";
  const entityPromptExact = "&country__exact=";
  const variablePromptExact = "&variable__exact=";
  const countryPromptIn = "&state__in=";
  const returnShape = "&_shape=array";
  const month_low_limit =
    dataset.apiDatasetTitle === "generation_monthly"
      ? "&date__gte=2015-01-01"
      : "";

  const countryString = selectedCountries.join("%2C+").replace(/\s/g, "+");

  let variableQuery;
  if (dataset.multipleSeries === true) {
    variableQuery = variablePromptExact + fuel.value;
  } else {
    variableQuery = "";
  }

  const url =
    baseURL +
    "/" +
    dataset.apiDatasetTitle +
    format +
    sort +
    entityPromptExact +
    entity +
    variableQuery +
    countryPromptIn +
    countryString +
    month_low_limit +
    returnShape;

  return url;
};

// Function that returns the url for a request for all countries
const createAllCountryRequest = (dataset, fuel, selectedYear) => {
  const baseURL = "https://ember-data-api-scg3n.ondigitalocean.app/ember";
  const format = ".json";
  const sort = "?_sort=rowid";
  const variablePromptExact = "&variable__exact=";
  const yearExact = "&year__exact=";
  const returnShape = "&_shape=array";

  let variableQuery;
  if (dataset.multipleSeries === true) {
    variableQuery = variablePromptExact + fuel.value;
  } else {
    variableQuery = "";
  }

  const url =
    baseURL +
    "/" +
    dataset.apiDatasetTitle +
    format +
    sort +
    variableQuery +
    yearExact +
    selectedYear +
    returnShape;

  return url;
};

export {
  createSingleCountryRequest,
  createMultiCountryRequest,
  createAllCountryRequest,
};
